(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.menu-drawer__menu-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const summary = link.closest('summary');
      const details = summary?.parentElement;
      if (details?.tagName === 'DETAILS') {
        details.open = !details.open;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sample-dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.sample-dropdown__item');
      if (!btn) return;

      const wrapper = btn.closest('product-form');
      if (!wrapper) return;

      const idInput = wrapper.querySelector('input[name="id"]');
      if (!idInput) return;

      idInput.value = btn.dataset.variantId || btn.value;
      idInput.disabled = false;
    },
    { capture: true }
  );

  window.handleDropdown = function () {
    document.getElementById('myDropdown').classList.toggle('show');
  };
  window.addEventListener('click', function (event) {
    if (!event.target.matches('.dropbtn')) {
      document.querySelectorAll('.dropdown-content.show').forEach((el) => el.classList.remove('show'));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
